import React from 'react';
import './style.css';

const Policy = () => {
  return (
    <div className="main">
      <p className="c10" id="h.gjdgxs">
        <span className="c19"></span>
      </p>
      <p className="c11">
        <span className="c17">
          DISPOSICIONES INTERNAS PARA REGULAR EL USO DE LOS VEH&Iacute;CULOS DEL BID EN COSTA RICA
        </span>
      </p>
      <p className="c10">
        <span className="c19"></span>
      </p>
      <p className="c11">
        <span className="c15">USO AUTORIZADO DE LOS VEH&Iacute;CULOS</span>
      </p>
      <ol className="c4 lst-kix_list_2-0 start" start="1">
        <li className="c9">
          <span className="c0">
            Los veh&iacute;culos ser&aacute;n utilizados solo para viajes de car&aacute;cter
            oficial.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            Como indican los manuales del Banco, su uso debe limitarse al territorio nacional.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            Los choferes asignados a los veh&iacute;culos ser&aacute;n los &uacute;nicos autorizados
            para manejar los veh&iacute;culos oficiales, o las personas autorizadas por el
            Representante.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            Solo los funcionarios seg&uacute;n lo establecido en el Manual CO-505
          </span>
          <span className="c0">
            &nbsp;ser&aacute;n atendidos en el aeropuerto internacional para su ingreso y salida del
            pa&iacute;s.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            El uso de los veh&iacute;culos del Banco durante tiempo extraordinario, as&iacute; como
            en d&iacute;as feriados y fines de semana deber&aacute; limitarse a actividades
            oficiales.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            Cualquier excepci&oacute;n al uso de los veh&iacute;culos fuera de las normas actuales
            debe ser consultada y aprobada por el Representante.
          </span>
        </li>
      </ol>
      <p className="c21">
        <span className="c0"></span>
      </p>
      <p className="c16">
        <span className="c15">ASIGNACION DE VEH&Iacute;CULOS Y CHOFERES</span>
      </p>
      <p className="c3">
        <span className="c6"></span>
      </p>
      <ol className="c4 lst-kix_list_3-0 start" start="1">
        <li className="c9">
          <span className="c0">
            Los choferes de CCR est&aacute;n asignados a diferentes tipos de labores, entre las
            cuales se incluyen: transporte de funcionarios en la ciudad para asuntos oficiales,
            tr&aacute;mites varios ante las diferentes instituciones, transporte de funcionarios en
            visitas de inspecci&oacute;n a los proyectos, otras tareas administrativas que les sean
            asignadas por su supervisor.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            La oficina en CR cuenta con dos choferes de planta y tres veh&iacute;culos.
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            El funcionario administrativo designado (Katerin Casco es la &uacute;nica encargada y
            responsable de coordinar la asignaci&oacute;n de choferes y veh&iacute;culos).{' '}
          </span>
        </li>
        <li className="c9">
          <span className="c0">
            La asignaci&oacute;n de estos se har&aacute; siguiendo los siguientes criterios:
          </span>
        </li>
      </ol>
      <p className="c7">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1 start" start="1">
        <li className="c5">
          <span className="c0">
            El Representante y el Equipo Gerencial (Jefe de Operaciones y Especialista en
            Planificaci&oacute;n y Administraci&oacute;n de Recursos, Economista de Pa&iacute;s)
            tendr&aacute;n prioridad para la asignaci&oacute;n de chofer con veh&iacute;culo en el
            horario que sea necesario. &nbsp; &nbsp;
          </span>
        </li>
        <li className="c5">
          <span className="c0">
            Los funcionarios de rango igual o superior a Jefe de Divisi&oacute;n podr&aacute;n
            solicitar transporte hacia y desde el aeropuerto durante sus visitas oficiales al
            pa&iacute;s.
          </span>
        </li>
        <li className="c5">
          <span className="c0">
            Las misiones que nos visiten de Washington, D. C. u otros pa&iacute;ses tendr&aacute;n
            prioridad en la asignaci&oacute;n de chofer de planta con veh&iacute;culo, siempre y
            cuando faciliten la agenda completa de su visita con al menos una semana de
            anticipaci&oacute;n a su llegada a Costa Rica. &nbsp;{' '}
          </span>
        </li>
        <li className="c5">
          <span className="c0">
            Las visitas de inspecci&oacute;n a los proyectos continuar&aacute;n en nivel de
            prioridad para la asignaci&oacute;n de veh&iacute;culos con chofer.
          </span>
        </li>
      </ol>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="5">
        <li className="c5">
          <span className="c0">
            Los tr&aacute;mites administrativos oficiales en RR.EE., Ministerio de Hacienda, ICE,
            bancos, compras corporativas, etc. ser&aacute;n atendidos por los choferes de CCR en el
            siguiente nivel de prioridad de asignaci&oacute;n.
          </span>
        </li>
      </ol>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="6">
        <li className="c5">
          <span className="c0">
            Cuando sea posible y los choferes no est&eacute;n atendiendo a funcionarios en las
            condiciones indicadas en los puntos 4.a, b, c, d, se asignar&aacute; transporte para las
            reuniones del staff dentro de la ciudad.
          </span>
        </li>
      </ol>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="7">
        <li className="c5">
          <span className="c0">
            En caso de que existan varias solicitudes de transporte y no se cuente con los choferes
            y veh&iacute;culos necesarios, el solicitante utilizar&aacute; los servicios de taxi u
            otro servicio de transporte y presentar&aacute; los gastos para reembolso de Caja Chica,
            esto en el caso de los funcionarios que viven en Costa Rica. En el caso de los
            funcionarios que nos visitan de misi&oacute;n, lo incluir&aacute;n en el estado de
            gastos.{' '}
          </span>
        </li>
      </ol>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="8">
        <li className="c5">
          <span className="c0">
            En caso de que no se cuente con chofer para la atenci&oacute;n de un servicio de
            transporte fuera de la ciudad, el solicitante informar&aacute; al funcionario
            administrativo designado con al menos cinco d&iacute;as de anticipaci&oacute;n para que
            contrate los servicios de un chofer temporal que manejar&iacute;a el tercer
            veh&iacute;culo de la COF si est&aacute; disponible.
          </span>
        </li>
      </ol>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="9">
        <li className="c5">
          <span className="c0">
            Cuando exista una solicitud de transporte y la Representaci&oacute;n no cuente ni con
            choferes ni con veh&iacute;culos para atenderla, el funcionario administrativo designado
            gestionar&aacute; la contrataci&oacute;n de un chofer y el alquiler de un
            veh&iacute;culo apropiado para la gira. &nbsp; Los costos del chofer temporal,
            as&iacute; como del veh&iacute;culo y cualquier otro gasto identificable relacionado con
            esta gira ser&aacute; cargado a la unidad que utilice el servicio.
          </span>
        </li>
      </ol>
      <p className="c3 c13">
        <span className="c0"></span>
      </p>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="10">
        <li className="c5">
          <span className="c0">
            En todo momento, los funcionarios pueden utilizar el servicio de taxi u otro servicio de
            transporte para asistir a reuniones oficiales y presentar el cobro por Caja Chica, o
            pueden utilizar su veh&iacute;culo personal y presentar el reporte correspondiente para
            el pago del kilometraje en que incurri&oacute;. &nbsp;Estos gastos ser&aacute;n cargados
            a la unidad correspondiente.
          </span>
        </li>
      </ol>
      <p className="c8">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_3-1" start="11">
        <li className="c5">
          <span className="c0">
            El funcionario administrativo designado decidir&aacute; la asignaci&oacute;n
            correspondiente del transporte de acuerdo con los recursos con que se cuente en el
            momento.{' '}
          </span>
        </li>
      </ol>
      <p className="c3">
        <span className="c6"></span>
      </p>
      <p className="c3">
        <span className="c6"></span>
      </p>
      <p className="c3">
        <span className="c6"></span>
      </p>
      <p className="c16">
        <span className="c17">COSTOS DEL SERVICIO</span>
      </p>
      <p className="c1">
        <span className="c17"></span>
      </p>
      <p className="c3">
        <span className="c6"></span>
      </p>
      <ol className="c4 lst-kix_list_4-0 start" start="1">
        <li className="c9">
          <span className="c0">
            Cuando se asignen los servicios de los choferes de planta para el transporte de
            funcionarios dentro de la ciudad, el sobretiempo que se genere deber&aacute; ser cargado
            a la unidad organizacional que utiliza el servicio.
          </span>
        </li>
      </ol>
      <p className="c7">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_4-0" start="2">
        <li className="c9">
          <span className="c0">
            En el caso de que los choferes de planta brinden transporte durante las visitas de
            inspecci&oacute;n, se cargar&aacute; a la unidad que utilice su servicio el costo del
            salario diario del chofer m&aacute;s el sobretiempo en caso de que lo requieran.
          </span>
        </li>
      </ol>
      <p className="c3 c13">
        <span className="c0"></span>
      </p>
      <p className="c7">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_4-0" start="3">
        <li className="c9">
          <span className="c0">
            Todos los gastos en que se incurra para la visita de inspecci&oacute;n (combustible,
            peajes, parqueos, otros) se cargar&aacute;n a la unidad que utilice el veh&iacute;culo.
          </span>
        </li>
      </ol>
      <p className="c7">
        <span className="c0"></span>
      </p>
      <ol className="c4 lst-kix_list_4-0" start="4">
        <li className="c9">
          <span className="c0">
            Los gastos de hospedaje, alimentaci&oacute;n, transporte y otros en que incurra el
            chofer para brindar el servicio ser&aacute;n cargados a la unidad correspondiente.
          </span>
        </li>
      </ol>
    </div>
  );
};

export default Policy;
